module.exports = __webpack_public_path__ + "img/field_ex_logo.2ad1f09c.png";